import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  RequestPollingReportDto,
  RequestReportSendEmailExcelDto,
  ResponseReportSendEmailExcelDto
} from "../dto/survey-service.dto";
import { NestApiProvider } from "../../nest-api";

@Injectable()
export class SurveyServiceNestApi {
  private service: string = '';
  private model: string = 'SurveyService';

  constructor(
    private nestApiProvider: NestApiProvider
  ) {
    
  }

  public downloadExcel(data) {
    const method: string = 'POST';
    const func: string = 'downloadExcel';
    const params: RequestPollingReportDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
  }

  public downloadPdf(data) {
    const method: string = 'POST';
    const func: string = 'downloadPdf';
    const params: RequestPollingReportDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
  }

  public reportSendEmailExcel(data: RequestReportSendEmailExcelDto): Observable<ResponseReportSendEmailExcelDto> {
    const method: string = 'POST';
    const func: string = 'reportSendEmailExcel';
    const params: RequestReportSendEmailExcelDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseReportSendEmailExcelDto>(method, url, params, urlParams, body);
  }

  public reportSendEmailPdf(data: RequestReportSendEmailExcelDto): Observable<ResponseReportSendEmailExcelDto> {
    const method: string = 'POST';
    const func: string = 'reportSendEmailPdf';
    const params: RequestReportSendEmailExcelDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseReportSendEmailExcelDto>(method, url, params, urlParams, body);
  }

  public getSurveyLists(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'getSurveyLists';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/survey-service-nest-api.ts